
const sellerOffers = {
    namespaced:true,
    state:{
        liveOffersSeller:[],
        liveTerminalPrices: [],
        dinTerminals:[],
        showSpotModal:false,
        showContractModal:false,
        filtersApply:false,
        filteredOffers:[],
        contractType:'', //indicate if the modal il for ex-rack or bunkering
        createOffer:{
            typeOfService:''
        },
        newOffers:[],        
        editingOffer:false,
        showUploadMatrix:false,
        newOfferBeenAdded:false,
        editWasSuccess:false,
        
        offersAvailability: '',
        theOfferToEdit:'',
        removeOfferData: '',
        offerToDuplicate: "",
        isDuplicatingOffer: "",
        offerInputIds: {
            BioPricing: "BIO_PRICING", 
            Brand: "BRAND", 
            Buyer: "BUYER", 
            Brand: "BRAND",
            CollectionPeriod: "COLLECTION_PERIOD", 
            ContractEndDate: "CONTRACT_END_DATE", 
            ContractFrequency: "CONTRACT_FREQUENCY", 
            ContractFrequencyQuantity: "CONTRACT_FREQUENCY_QUANTITY", 
            ContractReference: "CONTRACT_REFERENCE", 
            ContractStartDate: "CONTRACT_START_DATE", 
            ExternalContractId: "EXTERNAL_CONTRACT_ID", 
            Measurement: "MEASUREMENT", 
            MinOrderVolume: "MIN_ORDER_VOLUME",
            Network: "NETWORK", 
            PaymentTermOverride: "PAYMENT_TERM_OVERRIDE", 
            Premium: "PREMIUM", 
            PriceInput: "PRICE_INPUT", 
            PricingMethod: "PRICING_METHOD", 
            Product: "PRODUCT", 
            Terminal: "TERMINAL", 
            TotalPrice: "TOTAL_PRICE", 
            VolumeMax: "VOLUME_MAX",
            VolumeMin: "VOLUME_MIN"
        }
    },
    getters:{
        getTypeOfService:state=>{
            return state.createOffer.typeOfService
        },
        getOfferToEdit:state=>{
           return state.theOfferToEdit
        },
        getOffersKeyToEdit:state=>{
            return state.offerToEditKey
        },
        getContractsOffers_Bunkering:state=>{
            return state.newOffers.filter(offer=> offer.isContract && offer.storage_type_id==='BUNKERING')
        },
        getContractsOffers_Spot:state=>{
            return state.newOffers.filter(offer=> offer.isContract && offer.storage_type_id==='SPOT')
        },
        getOffersForBuyerFavourites:state=>{
            return state.newOffers
        },
        getEditingStatus:state=>{
            return state.editingOffer
        },
        liveOffersSeller(state){
            return state.liveOffersSeller;
        },
        offerInputIds: (state) => {
            return state.offerInputIds;
        }
    },
    actions:{
        getAllOffersForUser:({commit,rootState})=>{
            rootState.axios.get('/api/v2/offers')
                .then(response => {
                    commit('GET_ALL_OFFERS', response.data);
                }).catch(error=> console.log('error fetching offers ', error));
        },
        getDinTerminals:({commit,rootState})=>{
            const haulierAccountId = rootState.login.userLoggedIn.id
            rootState.axios.get('/api/getHaulageTerminalSettings', {params: {haulierAccountId}})
                .then(response => {
                    if(response.data.success){
                        const payload = response.data
                        commit('GET_DIN_TERMINALS', payload.terminalSettings)
                    }
                }).catch(error=> console.log('error DIN Termianls ', error))
        },
        openSpotModal:({commit})=>{
            commit('OPEN_SPOT_MODAL')
        },
        closeSpotModal:({commit})=>{
            commit('CLOSE_SPOT_MODAL')
        },
        openContractModal:({commit},payload)=>{
            commit('OPEN_CONTRACT_MODAL',payload)
        },
        closeContractModal:({commit})=>{
            commit('CLOSE_CONTRACTS_MODAL')
        },
        chooseServiceType:({commit},response)=>{
            commit('CHOOSE_SERVICE_TYPE',response)
        },
        saveNewOffer:({commit},response)=>{
            commit('SAVE_NEW_OFFER',response)
        },
        editOffer:({commit, rootState, dispatch}, payload) => {
            rootState.axios.get('/api/getSingleOffer', { params: { offerId: payload.offerId } })
                .then(res => {
                    commit('EDIT_OFFER', res.data.payload.offer);
                    
                    if (payload.offerType === "CONTRACT")
                        dispatch("openContractModal");
                    else
                        dispatch("openSpotModal");
                }).catch((error) => {
                    console.dir(error);
                    res.status(500).json({ message: "Server Error for GET Offer" });
                });
        },
        editingEnd:({commit})=>{
            commit('EDIT_END')
        },
        openUploadMatrixModal:({commit})=>{
            commit('OPEN_MATRIX_UPLOAD')
        },
        closeUploadMatrixModal:({commit})=>{
            commit('CLOSE_MATRIX_UPLOAD')
        },
        switchNewOffersToFalse:({commit})=>{
            commit('SWITCH_NEW_OFFER_TO_FALSE')
        },
        saveOffersOnTheStore:({commit},response)=>{
            commit('SAVE_OFFER_ON_THE_STORE',response)
        },
        updateSuccess:({commit})=>{
            commit('UPDATE_SUCCESS')
        },
        resetSuccessEditing:({commit})=>{
            commit('RESET_EDITING')
        },
        getOffersTimeAvailability: async ({commit, rootState}) => {
            const response = await rootState.axios.get('/api/getOffersTimeAvailability')

            if (response.data.success){
                commit('GET_OFFERS_TIME_AVAILABILITY', response.data.payload.settings.seller)
            }
        },
        setOffersTimeAvailability: async ({dispatch, rootState}, payload) => {
            const editingPayload = {
                data: payload
            }
            
            const response = await rootState.axios.put('/api/setOffersTimeAvailability', editingPayload)

            if (response.data.success){
                dispatch('notifications/displayActionConfirmation', {shown: true, message: 'Offers time availability saved'}, {root: true})
                dispatch('getOffersTimeAvailability')
            }
        },
        toggleOffersAvailability: async ({dispatch, rootState}, payload) => {
            const editingPayload = {
                data: payload
            }

            const response = await rootState.axios.put('/api/toggleOffersAvailability', editingPayload)

            if (response.data.success){
                dispatch('getOffersTimeAvailability')
            }
        },
        duplicateOffer: ({commit, rootState, dispatch}, payload) => {
            rootState.axios.get('/api/getSingleOffer', { params: { offerId: payload.offerId } } )
                .then(res => {
                    commit("DUPLICATE_OFFER", res.data.payload.offer);
                    dispatch("setOfferDuplicationStatus", true);
                    
                    if (payload.offerType === "CONTRACT")
                        dispatch("openContractModal");
                    else
                        dispatch("openSpotModal");
                }).catch((error) => {
                    console.dir(error);
                    res.status(500).json({ message: "Server Error for GET Offer" });
                });
        },
        setOfferDuplicationStatus: ({commit}, payload) => {
            commit("SET_OFFER_DUPLICATION_STATUS", payload);
        }
    },
    mutations:{
        OPEN_SPOT_MODAL:state=>{
            state.showSpotModal=true;
        },
        OPEN_CONTRACT_MODAL:(state,payload)=>{
            state.showContractModal = true;
            state.contractType = payload
        },
        GET_ALL_OFFERS:(state,payload)=>{
            state.liveOffersSeller = payload.offers.sort((a, b) => new Date(a.created) - new Date(b.created))
            state.liveTerminalPrices = payload.offers.filter(offer => !offer.isContract && offer.status_type_id === "ACTIVE").sort((a,b) => {
              // Sort offers by storage_type_id Z-A (bunkering last)
              const storageTypeA = a.storage_type_id.toUpperCase(); // ignore upper and lowercase
              const storageTypeB = b.storage_type_id.toUpperCase(); // ignore upper and lowercase
              if (storageTypeA < storageTypeB) return 1;
              if (storageTypeA > storageTypeB) return -1;
              // names must be equal
              return 0;
            })
        },
        GET_DIN_TERMINALS:(state,payload)=>{
            state.dinTerminals = payload
        },
        CHOOSE_SERVICE_TYPE:(state,payload)=>{
            state.createOffer.typeOfService=payload
        },
        CLOSE_SPOT_MODAL: state=> {
            state.showSpotModal=false},
        CLOSE_CONTRACTS_MODAL:state=> {
            state.showContractModal=false
        },
        SAVE_NEW_OFFER:(state,payload)=>{
            
            state.newOfferBeenAdded=true;
            state.newOffers.push(payload)
        },
        EDIT_OFFER:(state,payload)=>{
            state.theOfferToEdit=payload
            state.editingOffer=true;
        },
        EDIT_END:(state)=>{
            state.editingOffer=false;
        },
        OPEN_MATRIX_UPLOAD:state=>{
            state.showUploadMatrix=true
        },
        CLOSE_MATRIX_UPLOAD:state=> {
            state.showUploadMatrix=false
        },
        SWITCH_NEW_OFFER_TO_FALSE:(state)=>{
            state.newOfferBeenAdded=false;
        },
        SAVE_OFFER_ON_THE_STORE:(state,payload)=>{
            state.newOffers=''
            state.newOffers=payload
        },
        UPDATE_SUCCESS:(state)=>{
            state.editWasSuccess=true;
        },
        RESET_EDITING:(state)=>{
            state.editWasSuccess=false
        },
        GET_OFFERS_TIME_AVAILABILITY: (state, payload) => {
            state.offersAvailability = payload
        },
        DUPLICATE_OFFER: (state, offer) => {
            state.offerToDuplicate = offer;
        },
        SET_OFFER_DUPLICATION_STATUS: (state, payload) => {
            state.isDuplicatingOffer = payload;
        }
    }
}

export default sellerOffers